import Categories from './Categories/Categories';
import Brands from './Brands/Brands';
import Attributes from './Attributes/Attributes';
import Pricing from './Pricing/Pricing';
import CustomerGroups from './CustomerGroups/CustomerGroups';
import Languages from './Languages/Languages';

import request from '../../Helpers/Request';

class Connections {
    constructor(settings) {
        this.settings = settings;

        this.categories = new Categories(this.settings);
        this.brands = new Brands(this.settings);
        this.attributes = new Attributes(this.settings);
        this.pricing = new Pricing(this.settings);
        this.customerGroups = new CustomerGroups(this.settings);
        this.languages = new Languages(this.settings);
    }

    index(page) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections?page=${page}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    show(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    store(data) {
        return new Promise((resolve, reject) => {
            request('POST', '/clients/connections', this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${data.id}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    destroy(id) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/clients/connections/${id}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    sync(id, type) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/sync/${type}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    syncData() {
        return new Promise((resolve, reject) => {
            request('GET', '/clients/connections/state', this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    products(id, filters, page) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/sync/products?page=${page}`, this.settings, null, true, filters)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    productsSyncLog(id, filters, page) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/sync/logs?page=${page}`, this.settings, null, true, filters)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    productsShow(id, productId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/sync/products/${productId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    productPatch(id, productId, data) {
        return new Promise((resolve, reject) => {
            request('PATCH', `/clients/connections/${id}/sync/products/${productId}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    languagesIndex(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/languages/index`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getShopLanguage(id, languageId) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/languages/${languageId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    deliverytimes(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/deliverytimes/index`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

}

export default Connections;
